// extracted by mini-css-extract-plugin
export default {"layout":"ed15ea2b61 _605ab79c9c a0de84d17d","h_slide":"_6970ada174","category":"d82ff8f066 _7661268696 b75f0200a3"};